"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonRenderer = void 0;
var Renderer_1 = require("./Renderer");
var fabric_1 = require("fabric");
var chroma_js_1 = __importDefault(require("chroma-js"));
var HistoryCanvas_1 = require("../canvas/HistoryCanvas");
var PersonRenderer = /** @class */ (function (_super) {
    __extends(PersonRenderer, _super);
    function PersonRenderer(canvas, person) {
        var _this = _super.call(this, canvas) || this;
        _this.name = person.name;
        _this.birth = person.birth;
        _this.death = person.death;
        _this.events = person.events.sort(function (one, two) { return one.orderByStart(two); });
        _this.shortName = person.shortName;
        _this.url = person.url;
        _this.left = HistoryCanvas_1.HistoryCanvas.calculateAbsoluteX(person.birth);
        _this.width = HistoryCanvas_1.HistoryCanvas.calculateRelativeX(person.birth, person.death);
        return _this;
    }
    PersonRenderer.prototype.render = function (offset, color) {
        var _this = this;
        var rect = new fabric_1.fabric.Rect({
            fill: color.hex(),
            left: this.left,
            width: this.width,
            top: offset,
            height: this.LANE_HEIGHT,
        });
        var renderedEvents = this.events.map(function (it) { return _this.renderNestedEvent(it, offset, color); });
        var textColor = color.luminance() > 0.4 ? (0, chroma_js_1.default)('black').hex() : (0, chroma_js_1.default)('white').hex();
        var label = new fabric_1.fabric.Textbox(this.shortName, {
            left: this.left + this.width / 2,
            width: this.width,
            top: offset + this.LANE_HEIGHT / 2,
            originX: 'center',
            originY: 'center',
            fontSize: this.LANE_HEIGHT - 6,
            textAlign: 'center',
            strokeWidth: 0,
            fill: textColor
        });
        var personGlyph = new fabric_1.fabric.Group(__spreadArray(__spreadArray([rect], renderedEvents, true), [label], false), {
            tooltipText: this.buildPersonTooltip(),
            fill: color.hex(),
            url: this.url
        });
        this.canvas.add(personGlyph);
    };
    PersonRenderer.prototype.renderNestedEvent = function (event, offset, color) {
        return new fabric_1.fabric.Circle({
            fill: color.darken(0.3).hex(),
            left: HistoryCanvas_1.HistoryCanvas.calculateAbsoluteX(event.date),
            top: offset + this.LANE_HEIGHT / 2,
            originY: 'center',
            originX: 'center',
            radius: this.LANE_HEIGHT * 3 / 8,
            strokeWidth: 1,
            stroke: color.darken(0.9).hex()
        });
    };
    PersonRenderer.prototype.buildPersonTooltip = function () {
        var events = this.events.length > 0 ? '\n' + this.events.map(function (it) { return "".concat(it.name, " (").concat(it.date.year, ")"); }).join(', ') : '';
        return "".concat(this.name, "\n").concat(this.birth.year, " - ").concat(this.death.year).concat(events);
    };
    return PersonRenderer;
}(Renderer_1.Renderer));
exports.PersonRenderer = PersonRenderer;
